import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
const IconWrapper = /*#__PURE__*/styled('span')({
  name: "IconWrapper",
  class: "irdtb64",
  propsAsIs: false
});
const UnavailabilityContentElement = /*#__PURE__*/styled('div')({
  name: "UnavailabilityContentElement",
  class: "unedor0",
  propsAsIs: false
});
const UnavailabilityMessageWrapper = /*#__PURE__*/styled('div')({
  name: "UnavailabilityMessageWrapper",
  class: "u1c3pkpy",
  propsAsIs: false
});

/** Shared layout may be reused with alternative messages / CTAs */
export const SoldOutBase = ({
  headerSlot,
  contentSlot,
  actionSlot
}: {
  headerSlot: React.ReactNode;
  contentSlot: React.ReactNode;
  actionSlot?: React.ReactNode;
}) => <UnavailabilityMessageWrapper data-id="SoldOutBase">
    <Flex.Row alignItems="center">
      <IconWrapper>
        <Icon size="md" name="Forbid" />
      </IconWrapper>
      <Text variant="titleM">{headerSlot}</Text>
    </Flex.Row>
    {!!contentSlot && <UnavailabilityContentElement>{contentSlot}</UnavailabilityContentElement>}
    {!!actionSlot && actionSlot}
  </UnavailabilityMessageWrapper>;

require("./SoldOutBase.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SoldOutBase.tsx");